














import { Vue, Component } from "vue-property-decorator";
import RecordForm from "@/components/records/RecordForm.vue";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";

@Component({
  components: { CBreadCrumbs, RecordForm }
})
export default class RecordNew extends Vue {
  get breadcrumbs() {
    return [
      {
        to: { name: "records" },
        label: this.$tc(this.$translate.Records)
      },
      {
        label: this.$tc(this.$translate.Add)
      }
    ];
  }
}
